import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomereact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "replace",
	stroke: "replace",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0415 17.1858H18.9585V27H27V11.0929L15.8083 5L5 11.0929V27H13.0415V17.1858Z",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHomereact;
